import { Injectable } from '@angular/core';

@Injectable()
export class SignatureLayoutStorageService {
    public userEmail: string = '';
    constructor() { }
}
